import { useState } from "react";
import { Button } from "../ui/Button";
import { Modal } from "../ui/Modal";

interface TrashToolbarProps {
  itemCount: number;
  onEmptyTrash: () => void;
  isEmptying?: boolean;
}

export function TrashToolbar({ itemCount, onEmptyTrash, isEmptying = false }: TrashToolbarProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between border-b border-gray-800 bg-gray-900/50 px-4 py-3 md:px-6">
        <div>
          <h1 className="text-lg font-semibold text-gray-100">Trash</h1>
          <p className="text-xs text-gray-500">
            {itemCount} item{itemCount !== 1 ? "s" : ""} · Auto-deleted after 30 days
          </p>
        </div>
        {itemCount > 0 && (
          <Button variant="danger" size="sm" onClick={() => setConfirmOpen(true)} loading={isEmptying} disabled={isEmptying}>
            Empty Trash
          </Button>
        )}
      </div>

      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)} title="Empty Trash?">
        <div className="space-y-4">
          <p className="text-sm text-gray-400">
            This will permanently delete all {itemCount} items and free up storage.
            <strong className="block text-red-400 mt-1">This cannot be undone.</strong>
          </p>
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => setConfirmOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                onEmptyTrash();
                setConfirmOpen(false);
              }}
            >
              Delete {itemCount} items permanently
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
